<template>
  <div>
    <div class="row mt-3 mb-4">

      <div class="col-md human-body">
        <svg
          version="1.1"
          id="HumanBodySVG"
          class="gen-by-synoptic-designer"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 800 1350" preserveAspectRatio="xMaxYMax meet"
          xml:space="preserve"
        ><img style="margin: 8%" src="tech-stack/icons8-vue-js-50.png"/>
          <image href="img/poses/model.png" />
          <filter id="pictureFilter">
            <feGaussianBlur stdDeviation="2" />
          </filter>
          <polygon @click = "selectBodyPart(0, $event)"
            id="LeftElbow"
            title="LeftElbow"
            points="583,320,583,344,596,372,607,401,614,427,631,455,643,490,654,534,664,571,680,609,729,634,748,654,743,660,725,652,711,648,732,721,730,736,719,749,694,754,669,734,645,668,640,631,617,584,571,519,555,453,524,394,526,329,556,324"
          />
          <polygon @click = "selectBodyPart(1, $event)"
            id="LeftShoulder"
            title="LeftShoulder"
            points="486,231,525,236,550,247,564,260,576,277,583,297,583,310,574,316,528,323,517,287,501,271,491,251"
          />
          <polygon @click = "selectBodyPart(2, $event)"
            id="RightShoulder"
            title="RightShoulder"
            points="315,230,281,235,256,244,233,262,223,291,219,325,247,325,277,333,283,291,296,264"
          />
          <polygon @click = "selectBodyPart(3, $event)"
            id="RightElbow"
            title="RightElbow"
            points="220,332,213,357,188,418,158,480,144,545,117,608,58,646,52,658,63,662,92,648,69,729,72,739,90,755,110,748,122,732,134,732,151,685,161,645,162,624,226,528,245,466,274,393,276,340,246,333"
          />
          <polygon @click = "selectBodyPart(4, $event)"
            id="LeftHip"
            title="LeftHip"
            points="501,560,509,587,514,624,520,678,482,685,436,684,404,687,403,630,403,594,404,571,439,576,475,573"
          />
          <polygon @click = "selectBodyPart(5, $event)"
            id="RightHip"
            title="RightHip"
            points="301,555,322,572,354,578,395,571,395,609,397,687,360,689,322,682,281,675,289,607,295,569"
          />
          <polygon @click = "selectBodyPart(6, $event)"
            id="LeftKnee"
            title="LeftKnee"
            points="522,687,532,731,539,781,537,828,529,865,518,891,513,922,513,955,510,987,517,1017,514,1057,508,1101,514,1060,504,1144,500,1207,502,1231,517,1260,536,1283,542,1301,546,1313,536,1321,518,1328,499,1334,485,1320,475,1307,469,1275,451,1259,450,1239,453,1227,453,1207,459,1183,447,1095,446,1093,434,1056,441,968,429,909,420,835,411,773,412,720,404,695,438,693,484,692"
          />
          <polygon @click = "selectBodyPart(7, $event)"
            id="RightKnee"
            title="RightKnee"
            points="279,684,271,733,260,788,266,837,276,875,286,903,288,958,285,1010,288,1065,294,1132,301,1196,300,1214,298,1229,280,1266,261,1291,258,1313,267,1322,282,1330,299,1334,314,1324,322,1313,329,1291,333,1271,350,1257,350,1238,348,1216,345,1193,344,1165,353,1097,366,1056,367,1034,360,968,376,867,386,795,390,737,396,695,357,697,318,689"
          />
          <polygon @click = "selectBodyPart(8, $event)"
            id="LeftBody"
            title="LeftBody"
            points="479,230,461,226,444,225,420,228,402,231,401,333,402,461,402,563,438,570,474,567,499,553,504,532,502,505,500,472,511,435,519,410,521,370,522,332,518,300,503,282,492,261,483,237"
          />
          <polygon @click = "selectBodyPart(9, $event)"
            id="RightBody"
            title="RightBody"
            points="397,233,375,226,349,223,323,229,301,263,287,291,282,333,280,394,289,425,297,452,300,505,298,543,323,567,353,571,395,565,396,461,395,333,397,239"
          />
        </svg>
      </div>
      
      <div class="col-md selection">
        <h2>Selected Body Parts</h2>
        <ul class="mt-5">
          <div v-if="selectedBodyName.length == 0">No body part is selected</div>
          <div v-else>
            <li v-for="part in selectedBodyName" :key="part.id">
              {{part}}
            </li>
          </div>
        </ul>
      </div>
    </div>
  </div>
  
</template>

<script>

export default {
  data() {
    return {
      targetNames: [
        "Left Elbow",
        "Left Shoulder",
        "Right Shoulder",
        "Right Elbow",
        "Left Hip",
        "Right Hip",
        "Left Knee",
        "Right Knee",
        "Left Body",
        "Right Body",
      ],
      selectedBodyName: [],
      selectedBodyIndex: [],
    }
  },
  methods: {
    selectBodyPart(ind, event) {

      let currentInd = this.selectedBodyIndex.indexOf(ind)

      if (currentInd === -1) {
        event.target.style.setProperty('fill', '#57c9d5')
        event.target.style.setProperty('fill-opacity', '0.4')
        this.selectedBodyIndex.push(ind);
        this.selectedBodyName.push(this.targetNames[ind]);
      }
      else {
        event.target.style.removeProperty('fill')
        event.target.style.removeProperty('fill-opacity')

        this.selectedBodyIndex.splice(currentInd, 1);
        let removedNameInd = this.selectedBodyName.indexOf(this.targetNames[ind]);
        this.selectedBodyName.splice(removedNameInd, 1);
      }
    },
  }
  
}
</script>

<style>
@import './humanBody.css';
</style>
